import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as cartPreviewActions from "../actions/cartPreviewActions";
import ReadyAPIPage from "../pages/products/ReadyAPIPage";

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(cartPreviewActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReadyAPIPage);
